import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import AdminTopBar from "../Common/AdminTopBar";
import InterfaceMenu from "../Interfaces/InterfaceMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api_handler } from "../../services/api";
import { faSave, faGlobeEurope } from "@fortawesome/free-solid-svg-icons";
import Message from "../../components/Common/Messages";
import Cropper from "react-cropper";

import {
  GlobalStateContext,
  GlobalDispatchContext,
} from "../../state/GlobalContextProvider";

const View = ({ interface_id }, props) => {
  const themeState = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const [interfaceName, setInterfaceName] = useState(null);
  const [interfaceDesc, setInterfaceDesc] = useState(null);
  const [interfaceDomain, setInterfaceDomain] = useState(null);
  const [interfaceLogo, setInterfaceLogo] = useState(null);
  const [interfaceFavicon, setInterfaceFavicon] = useState(null);
  const [isSitePropogated, setIsSitePropogated] = useState(false);
  const [isReadyToCropLogo, setIsReadyToCropLogo] = useState(false);
  const [isReadyToCropFavicon, setIsReadyToCropFavicon] = useState(false);
  const [previewImageFavicon, setPreviewImageFavicon] = useState('');
  const [previewImageImage, setPreviewImageImage] = useState('');

  const [showAPIError, setShowAPIError] = useState(false);
  const [authMessageType, setAuthMessageType] = useState("");
  const [authMessageTitle, setAuthMessageTitle] = useState("");
  const [authMessageDesc, setAuthMessageDesc] = useState("");

  const [cropper, setCropper] = useState();

  const handleIntName = (event) => {
    setInterfaceName(event.target.value);
  };

  const handleIntDesc = (event) => {
    setInterfaceDesc(event.target.value);
  };

  const saveGeneralInfo = async () => {
    var data = {
      interface_id: interface_id,
      name: interfaceName,
      desc: interfaceDesc,
    };
    const api_rsp = await api_handler("int:update", data, "POST");
    
    if (api_rsp.code === 200) {
      getInterface();
      setAuthMessageType("success");
      setAuthMessageTitle("Updated!");
      setAuthMessageDesc('The interface details have been updated successfully');
      setShowAPIError(true);

    } else {

      setAuthMessageType("error");
      setAuthMessageTitle("Sorry!");
      setAuthMessageDesc(api_rsp.data.error);
      setShowAPIError(true);
    }

   
  };

  const checkPortalPropogated = useCallback(async () => {
    await fetch(interfaceDomain, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    })
      .then((response) => {
        setIsSitePropogated(true);
      })
      .catch((error) => {
        setIsSitePropogated(false);
      });
  },[interfaceDomain]);

  const getInterface = useCallback(async () => {
    var data = {
      interface_id: interface_id,
    };
    const api_rsp = await api_handler("int:view", data, "POST");
 
    setInterfaceName(api_rsp.data.name);
    setInterfaceDesc(api_rsp.data.desc);
    setInterfaceDomain(api_rsp.data.portal_domain);
    setInterfaceLogo(api_rsp.data.logo);
    setInterfaceFavicon(api_rsp.data.favicon);

    
  },[interface_id]);

  useEffect(() => {
    
    getInterface();
  }, [getInterface]);

  const getInterfaceRefresh = async () => {
    var data = {
      interface_id: interface_id,
    };
    const api_rsp = await api_handler("int:view", data, "POST");

    setInterfaceName(api_rsp.data.name);
    setInterfaceDesc(api_rsp.data.desc);
    setInterfaceDomain(api_rsp.data.portal_domain);
    setInterfaceLogo(api_rsp.data.logo);
    setInterfaceFavicon(api_rsp.data.favicon);

    
  }

  const cropperRef = useRef(null);

  const getLogoCropData = () => {
    if (typeof cropper !== "undefined") {
      //setCropData(cropper.getCroppedCanvas().toDataURL());
      uploadImageAsset(
        cropper.getCroppedCanvas().toDataURL(),
        "interface_logo"
      );
    }
  };

  const getFaviconCropData = () => {
    if (typeof cropper !== "undefined") {
     
      uploadImageAsset(
        cropper.getCroppedCanvas().toDataURL(),
        "favicon"
      );
    }
  };

  const checkForFaviconGraphic = (event) => {

    const file = event.target.files[0];
    const reader = new FileReader();

    reader.addEventListener(
      "load",
      function () {

        // preview.src = reader.result;
        setIsReadyToCropFavicon(true);
        setPreviewImageFavicon(reader.result)
       //  uploadImageAsset(reader.result, file.type);
      },
      false
    );

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const checkForLogoGraphic = (event) => {
    
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.addEventListener(
      "load",
      function () {
        
        // preview.src = reader.result;
        setIsReadyToCropLogo(true);
        setPreviewImageImage(reader.result)
        // uploadImageAsset(reader.result, asset_type);
      },
      false
    );

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const uploadImageAsset = async (dataUrl, asset_type) => {

    setInterfaceLogo('');
    var data = {
      interface_id: interface_id,
      asset_type: "image",
      asset_tag: asset_type,
      image_type: "png",
      asset: dataUrl,
    };
    const api_rsp = await api_handler("int-asset:update", data, "POST");
    //setCropData("#");
   
   
    if (api_rsp.code === 200) {
      //getInterfaceRefresh();
      setIsReadyToCropLogo(false);
      setIsReadyToCropFavicon(false);
      setPreviewImageImage('')
      setPreviewImageFavicon('')
      if (typeof window !== `undefined`) {
      window.location.reload(false);
      }
    }
  };

  return (
    <div>
      <AdminTopBar interface_id={interface_id} />
      <div className="section__master">
        <div className="grid grid-cols-12 gap-6">
         {/** <InterfaceMenu interface_id={interface_id} /> */}
          <div className="col-span-12 lg:col-span-12 xxl:col-span-12">
            <div className="Section__body">
              <div className="intro-y box">
                <div className="flex items-center  pt-0 border-b border-gray-200">
                  <h2 className="font-medium text-base mr-auto">
                    General Information
                  </h2>
                </div>{showAPIError? (
                  <Message
                    infoType={authMessageType}
                    infoTitle={authMessageTitle}
                    infoDesc={authMessageDesc}
                  />
                ) : null}
                <div className="p-lg-5">
                  <div className="grid grid-cols-12 gap-5">
                    <form
                      id="page_form"
                      className="col-span-12 xl:col-span-12"
                      novalidate="novalidate"
                    >
                      <div className="form-group">
                        <div className="mt-3">
                          <label
                            htmlFor="interface_name"
                            className="flex flex-col sm:flex-row"
                          >
                            Interface Name
                            <span
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title=""
                              data-original-title="Provide a name for your Interface - this will be visible to your users and account providers"
                            >
                              &nbsp;&nbsp;&nbsp;
                              <i className="ti-info-alt text-primary"></i>
                            </span>
                            <span className="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                              * Mandatory
                            </span>
                          </label>
                          <input
                            type="text"
                            id="interface_name"
                            className="input w-full border mt-2"
                            placeholder="Interface Name"
                            name="interface_name"
                            value={interfaceName}
                            onChange={handleIntName}
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="mt-3">
                          <label className="flex flex-col sm:flex-row">
                            Interface Description{" "}
                            <span
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title=""
                              data-original-title="Provide a description for your Interface - this will be visible to your users and account providers"
                            >
                              &nbsp;&nbsp;&nbsp;
                              <i className="ti-info-alt text-primary"></i>
                            </span>
                            <span className="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                              * Mandatory
                            </span>
                          </label>
                          <textarea
                            id="interface_desc"
                            className="input w-full border mt-2"
                            name="interface_desc"
                            rows="4"
                            placeholder="Interface Description"
                            cols="50"
                            value={interfaceDesc}
                            onChange={handleIntDesc}
                          ></textarea>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="mt-3">
                          <label className="flex flex-col sm:flex-row">
                            Chosen Interface Domain{" "}
                            <span
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title=""
                              data-original-title="This is the URL of your developer portal. Please contact us if you’d like to edit"
                            >
                              &nbsp;&nbsp;&nbsp;
                              <i className="ti-info-alt text-primary"></i>
                            </span>
                            <span className="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                              * Mandatory
                            </span>
                          </label>
                          <div>
                            <a
                              href={interfaceDomain}
                              target="_blank"  rel="noreferrer"
                              className={
                                isSitePropogated
                                  ? "notSitePropogated"
                                  : "isSitePropogated"
                              }
                            >
                              <button
                                className="cca-link-btn"
                                id="login_button"
                                type="button"
                              >
                                <div>
                                  <i className="sbmt_but_icon">
                                    <FontAwesomeIcon icon={faGlobeEurope} />
                                  </i>
                                  {interfaceDomain}
                                  <span></span>
                                </div>
                                <span></span>
                              </button>
                            </a>
                          </div>
                          <div className="subdomain_err"></div>
                        </div>
                      </div>

                      <div className="text-left mt-5">
                        <button
                          className="cca-btn"
                          id="login_button"
                          type="button"
                          onClick={saveGeneralInfo}
                        >
                          <div>
                            Save<span></span>
                            <i className="sbmt_but_icon">
                              <FontAwesomeIcon icon={faSave} />
                            </i>
                          </div>
                          <span></span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="Section__body">
              <div className="intro-y box">
                <div className="flex items-center  pt-0 border-b border-gray-200">
                  <h2 className="font-medium text-base mr-auto">
                    Graphical &amp; Logos
                  </h2>
                </div>
                <div className="p-lg-5">
                  <div className="intro-y box lg:mt-5">
                    <div className="intro-y box lg:mt-5">
                      <div className={"card card-form " + themeState.theme}>
                        <div className="row no-gutters">
                          <div className="col-lg-4 card-body">
                            <p>
                              <strong className={"upl_hdr " + themeState.theme}>
                                Development Portal Logo
                              </strong>
                            </p>
                            <p className="upl_txt">
                              You can change the developer portal logo here.
                              Simply click the upload box and confirm to
                              instantly update your portals logo.
                            </p>
                          </div>
                          <div className="col-lg-4 card-form__body card-body  align-items-center cur_asset_box">
                            <p className="cur_asset_prv_header">Current Portal Logo</p>
                            <div className="interfaceLogo">
                             
                                <img
                                  src={interfaceLogo}
                                  alt="Interface Developer Portal Logo"
                                />
                           
                            </div>
                          </div>
                          <div className="col-lg-4 card-form__body card-body d-flex align-items-center">
                            {isReadyToCropLogo ? (
                              <div className="custom_dropzone">
                                <p className="cropInfo">
                                  Please resize image to the crop box below
                                </p>
                                <Cropper
                                  src={previewImageImage}
                                  style={{
                                    height: 100,
                                    width: "95%",
                                    padding: 7,
                                  }}
                                  // Cropper.js options
                                  dragMode={"move"}
                                  aspectRatio={193 / 43}
                                  autoCropArea={4}
                                  restore={false}
                                  guides={false}
                                  center={false}
                                  highlight={false}
                                  cropBoxMovable={false}
                                  cropBoxResizable={false}
                                  toggleDragModeOnDblclick={false}
                                  minContainerHeight={100}
                                  minContainerWidth={200}
                                  ref={cropperRef}
                                  onInitialized={(instance) => {
                                    setCropper(instance);
                                  }}
                                />
                                <div className="text-right">
                                  <button
                                    className="cca-btn"
                                    id="login_button"
                                    type="button"
                                    onClick={getLogoCropData}
                                  >
                                    <div>
                                      Save<span></span>
                                      <i className="sbmt_but_icon">
                                        <FontAwesomeIcon icon={faSave} />
                                      </i>
                                    </div>
                                    <span></span>
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="custom_dropzone">
                                <div className="testBox">
                                  <label
                                  htmlFor="file-upload"
                                    for="file-upload"
                                    className="label-class"
                                  >
                                    <p>Drop files here to upload</p>
                                  </label>
                                  <input
                                    id="file-upload"
                                    type="file"
                                    className="avatar_file_input"
                                    onChange={checkForLogoGraphic}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className={"card card-form mt-3 " + themeState.theme}
                      >
                        <div className="row no-gutters">
                          <div className="col-lg-4 card-body">
                            <p>
                              <strong className={"upl_hdr " + themeState.theme}>
                                Development Portal Favicon
                              </strong>
                            </p>
                            <p className="upl_txt">
                              You can change the developer portal favicon here.
                              Simply click the upload box and confirm to
                              instantly update your portals favicon.
                            </p>
                          </div>
                          <div className="col-lg-4 card-form__body card-body  align-items-center cur_asset_box">
                            <p className="cur_asset_prv_header">Current Portal Favicon</p>
                            <div className="interfaceLogo">
                              
                                <img
                                  src={interfaceFavicon}
                                  alt="Interface Developer Portal Favicon"
                                />
                            
                            </div>
                          </div>
                          <div className="col-lg-4 card-form__body card-body d-flex align-items-center">
                            {isReadyToCropFavicon ? (
                              <div className="custom_dropzone">
                                <p className="cropInfo">
                                  Please resize image to the crop box below
                                </p>
                                <Cropper
                                  src={previewImageFavicon}
                                  style={{
                                    height: 100,
                                    width: "95%",
                                    padding: 7,

                                  }}
                                  // Cropper.js options
                                  dragMode={"move"}
                                  aspectRatio={1 / 1}
                                  autoCropArea={1}
                                  restore={false}
                                  guides={false}
                                  center={false}
                                  highlight={false}
                                  cropBoxMovable={false}
                                  cropBoxResizable={false}
                                  toggleDragModeOnDblclick={false}
                                  ref={cropperRef}
                                  onInitialized={(instance) => {
                                    setCropper(instance);
                                  }}
                                />
                                <div className="text-right">
                                  <button
                                    className="cca-btn"
                                    id="login_button"
                                    type="button"
                                    onClick={getFaviconCropData}
                                  >
                                    <div>
                                     <span></span>
                                      <i className="sbmt_but_icon">
                                        <FontAwesomeIcon icon={faSave} />
                                      </i>
                                    </div>
                                    <span></span>
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="custom_dropzone">
                                <div className="testBox">
                                  <label
                                  htmlFor="favicon-upload"
                                    for="favicon-upload"
                                    className="label-class"
                                  >
                                    <p>Drop files here to upload</p>
                                  </label>
                                  <input
                                    id="favicon-upload"
                                    type="file"
                                    className="avatar_file_input"
                                    onChange={checkForFaviconGraphic}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
